'use client';

import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { Button } from '@flipster/react/design-system/button';
import segment from '@flipster/utils/segment';
import { CommunityEvent } from '@flipster/utils/segment/events/community';

export { shareThisTradeBunja } from './state';

interface ShareThisTradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onExit: () => void;
}

export const ShareThisTradeModal = ({ isOpen, onClose, onConfirm, onExit }: ShareThisTradeModalProps) => {
  const t = useTranslations();
  return (
    <Modal isOpen={isOpen} onExit={onExit}>
      <Modal.Close onClose={onClose} />
      <Modal.Header>
        <Modal.Title
          label={t('Autogen_common.r251126.s_Share_this_trade_in_the_feed')}
          css={{ textStyle: 'Title/M', color: 'content.default.level-5' }}
        />
      </Modal.Header>
      <Modal.Content css={{ textStyle: 'Text/L/Regular', color: 'content.default.level-3' }}>
        <FormattedMessage id='Autogen_common.r251126.s_Share_your_trade_in_the_feed_and_engage_with_fellow_trader' />
      </Modal.Content>
      <Modal.Footer>
        <Button
          hierarchy='secondary'
          size='large'
          color='neutral'
          label={t('Common.r250401.Cancel')}
          onClick={() => {
            segment.track(CommunityEvent.FeedShareButtonClick, {
              button_text: 'Cancel',
            });
            onClose();
          }}
        />
        <Button
          size='large'
          withSpinner
          label={t('Autogen_common.r251126.s_Share_now')}
          onClick={() => {
            segment.track(CommunityEvent.FeedShareButtonClick, {
              button_text: 'Share now',
            });
            onConfirm();
            onClose();
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};
